module.exports = __webpack_public_path__ + "static/media/poster.476e8ba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/poster.png
// module id = 65
// module chunks = 0